<form [formGroup]="formGroup">
  <div formArrayName="experiences">
    <div class="card-data text-center" *ngIf="experiences.length === 0">
      <p>{{ "NoWorkExperience" | translate }}</p>
      <p class="text-muted">{{ "ClickToAddWorkExperience" | translate }}</p>
    </div>

    <div class="card-data" *ngFor="let experience of experiences.controls; let i = index" [formGroupName]="i">
      <div class="d-flex">
        <h4>
          {{ "Work Experience" | translate }}
        </h4>
        <i (click)="removeExperience(i)" class="col-auto bi bi-trash3 delete-icon"></i>
      </div>

      <label>{{ "Job title" | translate }} <span style="color: red;">*</span></label>
      <input type="text" formControlName="title" placeholder="{{ 'Enter your Job title' | translate }}"
        [class.error]="hasError(i, 'title')" />
      <span class="error-message" *ngIf="hasError(i, 'title')" style="color: red;">
        {{ "Job title is required" | translate }}
      </span>

      <label>{{ "Company Name" | translate }} <span style="color: red;">*</span></label>
      <input type="text" formControlName="company" placeholder="{{ 'Enter Your Company Name' | translate }}"
        [class.error]="hasError(i, 'company')" />
      <span class="error-message" *ngIf="hasError(i, 'company')" style="color: red;">
        {{ "Company name is required" | translate }}
      </span>

      <div class="d-flex justify-content-between">
        <div class="date">
          <label>{{ "Start Date" | translate }} <span style="color: red;">*</span></label>
          <input type="date" formControlName="startDate" placeholder="{{ 'Select date' | translate }}"
            [class.error]="hasError(i, 'startDate')" />
          <span class="error-message" *ngIf="hasError(i, 'startDate')" style="color: red;">
            {{ "Start date is required" | translate }}
          </span>
        </div>
        <div class="date">
          <label>
            {{ "End Date" | translate }}
            <span style="color: red;" *ngIf="!experience.get('isCurrent')?.value">*</span>
          </label>
          <input type="date" formControlName="endDate" placeholder="{{ 'Select date' | translate }}"
            [class.error]="hasError(i, 'endDate')" />
          <span class="error-message" *ngIf="hasError(i, 'endDate')" style="color: red;">
            {{ "End date is required" | translate }}
          </span>
        </div>
      </div>


      <div class="d-flex align-items-center mt-3">
        <p-inputSwitch formControlName="isCurrent"></p-inputSwitch>
        <label class="m-0 mx-2">{{ "Current Position" | translate }}</label>
      </div>

      <label>{{
        "Add numeric Achievements & Duties as possible" | translate
        }}</label>
      <textarea type="text" formControlName="dutiesAchievements"
        placeholder="{{ 'AchievementsDuties' | translate }}"></textarea>
    </div>

    <div class="card-data add-new" (click)="addExperience()">
      <h6>{{ "Add New Work experience" | translate }}</h6>
      <i class="bi bi-plus-circle"></i>
    </div>

    <div class="next-container px-4">
      <button class="border-button m-3" (click)="onPrevious()">
        {{ "Back" | translate }}
      </button>
      <button class="gradient-button m-3" (click)="onNext()">
        {{ "Next" | translate }}
      </button>
    </div>
  </div>
</form>